module.exports = __webpack_public_path__ + "img/icon_map_36_off_001.19f8b610.png";